import { Box, Portal } from '@mui/material'
import { useTranslation } from 'react-i18next'

import BannerAlert from '../banner-alert/banner-alert.component'
import { SEVERITY, SIZE } from '../banner-alert/banner-alert.constants'
import Button from '../button/button.component'
import { BUTTON_VARIANTS } from '../button/button.constants'
import useUnsavedChangesStore from '../../../stores/unsaved-changes.store'

import { styles } from './unsaved-changes-banner.styles'

const UnsavedChangesBanner = () => {
  const { t } = useTranslation('common')
  const isOpen = useUnsavedChangesStore((state) => state.isOpen)
  const handleKeep = useUnsavedChangesStore((state) => state.handleKeep)
  const handleDiscard = useUnsavedChangesStore((state) => state.handleDiscard)

  if (!isOpen) return null

  // Portal to document.body so the banner isn't trapped inside an ancestor
  // stacking context (e.g. any layout wrapper with transform/filter set),
  // which was causing it to render behind the Dialog backdrop in core.
  return (
    <Portal>
      <Box sx={styles.container}>
        <Box sx={styles.content}>
          <BannerAlert
            severity={SEVERITY.INFO}
            message={t('unsavedChanges.message')}
            size={SIZE.MEDIUM}
            hasBackground
            isMessageBold
            sx={styles.banner}
          />
          <Box sx={styles.actions}>
            <Button
              label={t('unsavedChanges.keep')}
              onClick={handleKeep}
              variant={BUTTON_VARIANTS.TEXT}
            />
            <Button
              label={t('unsavedChanges.discard')}
              onClick={handleDiscard}
              variant={BUTTON_VARIANTS.CONTAINED}
            />
          </Box>
        </Box>
      </Box>
    </Portal>
  )
}

export default UnsavedChangesBanner
